<template>
  <div class="admin admin--list-lot u-indent-m-b-45px">
    <filters @showReport="onShowReportClick" @clear="onFilterClearClick" ></filters>
    <template v-if="report && report.length > 0">
      <report :report="report"
              :type="filters.reportType"
              @export="onExportClick">
      </report>
    </template>
    <h3 v-else-if="report">
      {{$t('form.reports.nothing-is-found')}}
    </h3>
  </div>
</template>

<script>
  import Filters from './Filters'
  import Report from './Report'
  import Error from '@/api/types/errors'
  import TemplateItem from "../catalogs/templates/TemplateItem";

  export default {
    components: {
      TemplateItem,
      Filters,
      Report,
      //Pagination
    },

    data: () => ({
      report: undefined,
      filters: undefined,
      page: 1,
      pageSize: 5
    }),

    methods: {
      async onShowReportClick(filters) {
        this.runBlockerAction(async () => {
          try {
            this.report = await this.$store.dispatch('fetchReport', filters);
            this.filters = filters;
          }
          catch(e) {
            console.error('unable to fetch report', e);

            if (e instanceof Error && e.NOT_FOUND) {
              this.report = [];
            }
            else {
              this.globalErrorHandler(e);
            }
          }
        });
      },

      async onExportClick() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('exportReport', this.filters);
          }
          catch(e) {
            console.error('unable to export report', e);
            this.globalErrorHandler(e);
          }
        });
      },

      onFilterClearClick() {
        this.filters = undefined;
        this.report = undefined;
      }
    }
  }
</script>

<style scoped>
</style>
